import Model from 'mixins/model';

export default class UserModel extends Model {
    constructor() {
        super();
    }
    isLogged() {
      return !!this.get('type');
    }
    isAuthor() {
        return this.get('type') === 'author';
    }
    isAuthorOf(model) {
      return this.get('username') === model.get('User').get('username');
    }
    isModerator() {
        return !!this.get('isModerator');
    }
    isBanned() {
      return !!this.get('isBanned');
    }
    isInModerationMode() {
      return !!this.get('isInModerationMode');
    }

    hasDarkMode() {
        const additionalSettings = this.get('additionalSettings');
        if (!additionalSettings) {
            return false;
        }
        return !!additionalSettings.darkMode;
    }

    areAdditionalSettingsEnabled() {
        const additionalSettings = this.get('additionalSettings');
        if (!additionalSettings) {
            return false;
        }
        return !!additionalSettings.enabled;
    }

    changeModerationMode() {
      const isInModerationMode = !this.get('isInModerationMode');
      this.set('isInModerationMode', isInModerationMode);
      this.fireEvent('changedModerationMode');
    }
    static fromJSON(data = {}) {
        const {
            id,
            username,
            email,
            displayName,
            avatar,
            type,
            isModerator,
            isBanned,
            banEndsAt,
            activityDetails,
            additionalSettings,
        } = data;

        const userModel = new UserModel();

        userModel.set('id', id);
        userModel.set('username', username);
        userModel.set('email', email);
        userModel.set('displayName', displayName);
        userModel.set('thumbnail', avatar);
        userModel.set('type', type);
        userModel.set('isModerator', isModerator);
        userModel.set('isBanned', isBanned);
        userModel.set('banEndsAt', banEndsAt);
        userModel.set('isInModerationMode', false);
        userModel.set('activityDetails', activityDetails);
        userModel.set('additionalSettings', additionalSettings);
        if (additionalSettings) {
            userModel.set('hasDarkMode', additionalSettings.darkMode);
            userModel.set('areAdditionalSettingsEnabled', additionalSettings.enabled);
        } else {
            userModel.set('hasDarkMode', false);
            userModel.set('areAdditionalSettingsEnabled', false);
        }

        return userModel;
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/UserModel.js